import dlv from 'dlv';
import { fetchSCS } from '@cube/utils/lib/scs-api';
import { serialize } from './utils';

/***** Fetch Article List Start *****/
export function fetchArticleList(props) {
	if (dlv(props, 'dailymotionParams.playlistId')) {
		return fetchArticlesFromDailyMotionPlaylist(props);
	}
	if (dlv(props, 'dailymotionParams.channelId')) {
		return fetchArticlesFromDailyMotionChannel(props);
	}
	//else it is scs
	return fetchArticlesFromSCS(props);
}

function fetchArticlesFromDailyMotionPlaylist({ startContentServiceOrigin, streamClient, dailymotionParams, ...props }) {
	return fetchSCS(`/dailymotion/playlist/${dailymotionParams.playlistId}/`, streamClient, startContentServiceOrigin);
}

function fetchArticlesFromDailyMotionChannel({ startContentServiceOrigin, streamClient, dailymotionParams, ...props }) {
	return fetchSCS(`/dailymotion/channel/${dailymotionParams.channelId}/`, streamClient, startContentServiceOrigin);
}

function fetchArticlesFromSCS({ feed, ...props }) {
	if (feed) {
		return fetchArticlesFeedFromSCS({ feed, ...props });
	}
	return fetchArticlesListFromSCS(props);
}

function fetchArticlesFeedFromSCS({ startContentServiceOrigin, streamClient, feed, searchTerm, imageSizes, count, offset, ignoreId, ...props }) {
	let queryParams = {};

	if (imageSizes) queryParams.imageSizes = imageSizes;

	if (count) queryParams.count = count;
	if (offset) queryParams.offset = offset;
	if (searchTerm) queryParams.searchTerm = searchTerm;
	if (ignoreId) queryParams.ignoreId = ignoreId;

	return fetchSCS(`/articles/feed/${feed}/${serialize(queryParams)}`, streamClient, startContentServiceOrigin);
}

function fetchArticlesListFromSCS({ startContentServiceOrigin, streamClient, imageSizes, count, offset, vendor, ...props }) {
	let queryParams = {};

	if (imageSizes) queryParams.imageSizes = imageSizes;

	if (count) queryParams.count = count;
	if (offset) queryParams.offset = offset;
	if (vendor) queryParams.vendors = vendor;

	return fetchSCS(`/articles/list/${serialize(queryParams)}`, streamClient, startContentServiceOrigin);
}

/***** Fetch Article List End *****/


/***** Fetch Video Start *****/
export function fetchVideoData({ startContentServiceOrigin, streamClient, article, imageSizes }) {
	let queryParams = {};

	if (imageSizes) queryParams.imageSizes = imageSizes;

	return fetchSCS(`/video/id/${article}/${serialize(queryParams)}`, streamClient, startContentServiceOrigin);
}

/***** Fetch Video End *****/


/***** Fetch Article Start *****/
export function fetchArticleData({ startContentServiceOrigin, streamClient, article }) {
	return fetchSCS(`/articles/id/${article}/`, streamClient, startContentServiceOrigin);
}

/***** Fetch Article End *****/


/***** Fetch Feed Start *****/
export function fetchFeed({ feed, startContentServiceOrigin, streamClient }) {
	return fetchSCS(`/feeds/id/${feed}/`, streamClient, startContentServiceOrigin);
}

/***** Fetch Feed End *****/


/***** Fetch Alerts Start *****/
export function fetchAlerts({ feed, startContentServiceOrigin, streamClient }) {
	return fetchSCS(`/alerts/id/${feed}/`, streamClient, startContentServiceOrigin);
}

/***** Fetch Alerts End *****/


/***** Fetch Firebase Start *****/
export function fetchFirebase({ path, startContentServiceOrigin, streamClient }) {
	return fetchSCS(`/firebase/rtdb/${path}/`, streamClient, startContentServiceOrigin);
}

/***** Fetch Firebase End *****/


/***** Fetch Trending Articles Start *****/
export function fetchTrending({ startContentServiceOrigin, streamClient, imageSizes, count, days, vendor, provider }) {
	let queryParams = {};

	if (imageSizes) queryParams.imageSizes = imageSizes;
	if (count) queryParams.count = count;
	if (days) queryParams.days = days;
	if (vendor) queryParams.vendor = vendor;
	if (provider) queryParams.provider = provider;

	return fetchSCS(`/articles/trending/${serialize(queryParams)}`, streamClient, startContentServiceOrigin);
}

/***** Fetch Trending Articles End *****/
